
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StripeCheckoutService from '@/Services/Subscription/StripeCheckoutService';
import VeeValidateRefs from '@/Models/VeeValidateRefs';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '@/store';
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class VatIdEdit extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop()
  isTeamUpdating!: boolean;

  team = store.state.auth.team;

  $refs!: {
    // Used for validation of the form data e.g. customer, address etc.
    observer: VeeValidateRefs;
  };

  // Handles business logic and some of the form state
  stripeCheckoutService: StripeCheckoutService = new StripeCheckoutService();

  async update(): Promise<void> {
    if (await this.$refs.observer.validate()) {
      this.team.vat_id = this.stripeCheckoutService.customer.tax_id_data.value;
      await store.dispatch('auth/updateTeam', this.team).then(() => {
        this.$emit('cancel');
      });
    }
  }

  cancel(): void {
    this.$emit('cancel');
  }

  handlePrefillData(): void {
    // Init customer data for prefilling the form
    this.stripeCheckoutService.initCustomerData();
  }

  @Watch('open')
  onOpenChange(open: boolean): void {
    if (!open) {
      this.handlePrefillData();
      return;
    }
  }

  async created(): Promise<void> {
    this.handlePrefillData();
  }
}
